import { makeStyles } from "@material-ui/core";
import { colors } from "~/utils/colors";

const { white, brand } = colors;

const MuiStylesAppointmentCancelDialog = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "0",
    maxWidth: "480px",
    width: "100%",
    height: "100dvh",
    margin: "0",
    maxHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    position: "relative",
    [theme.breakpoints.up("md")]: {
      maxWidth: "480px",
      width: "480px",
      height: "auto",
      maxHeight: "90vh",
      margin: "40px auto",
      borderRadius: "16px",
      overflow: "hidden",
    },
  },
  dialogHeader: {
    padding: "20px 24px 16px",
    backgroundColor: white,
    borderBottom: "none",
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#333",
    margin: 0,
  },
  closeButton: {
    minWidth: "auto",
    padding: "8px",
    color: "#666",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  dialogContent: {
    padding: "24px 16px",
    paddingTop: "calc(env(safe-area-inset-top) + 24px)",
    paddingBottom: "0",
    backgroundColor: white,
    flex: "1 1 auto",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    gap: "16px",
    [theme.breakpoints.up("md")]: {
      padding: "32px",
      paddingTop: "32px",
      paddingBottom: "32px",
    },
  },
  warningWrapper: {
    marginTop: "8px",
  },
  warningSection: {
    width: "100%",
    padding: "8px",
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    backgroundColor: "rgba(228, 26, 74, 0.03)",
    borderRadius: "8px",
    border: "1px solid rgba(228, 26, 74, 0.2)",
  },
  warningIcon: {
    width: "36px",
    height: "36px",
    minWidth: "36px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  warningIconSvg: {
    fontSize: "22px",
    color: "#8C1837",
  },
  warningTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#8C1837",
    marginBottom: "4px",
  },
  warningMessage: {
    fontSize: "13px",
    color: "#5B2B33",
    lineHeight: "1.5",
  },
  successContainer: {
    padding: "40px 24px",
    textAlign: "center",
    backgroundColor: "white",
  },
  successIcon: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "#c6f6d5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 24px",
  },
  successIconSvg: {
    fontSize: "48px",
    color: "#38a169",
  },
  successTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2f855a",
    marginBottom: "12px",
  },
  successMessage: {
    fontSize: "14px",
    color: "#4a5568",
    lineHeight: "1.5",
  },
  detailsCard: {
    margin: "0",
    borderRadius: "0",
    boxShadow: "none",
    backgroundColor: white,
    paddingTop: "20px",
    paddingBottom: "16px",
    flexShrink: 0,
  },
  detailsTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#2d3748",
    marginBottom: "8px",
    paddingBottom: "12px",
    borderBottom: "1px solid #e2e8f0",
  },
  businessSection: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },
  businessAvatar: {
    width: "48px",
    height: "48px",
    backgroundColor: "#8C1837",
    color: "white",
    fontSize: "16px",
    fontWeight: "bold",
    marginRight: "12px",
    borderRadius: "8px",
  },
  businessInfo: {
    flex: 1,
  },
  businessName: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#2d3748",
    marginBottom: "4px",
  },
  businessAddress: {
    fontSize: "12px",
    color: "#718096",
  },
  appointmentInfo: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "8px",
  },
  appointmentDate: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#2d3748",
    marginBottom: "2px",
  },
  appointmentTime: {
    fontSize: "14px",
    color: "#4a5568",
  },
  professionalSection: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "8px",
  },
  detailIcon: {
    fontSize: "22px",
    color: "#222",
  },
  professionalAvatar: {
    width: "40px",
    height: "40px",
    marginRight: "12px",
    border: "2px solid #e2e8f0",
  },
  professionalInfo: {
    flex: 1,
  },
  professionalName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#2d3748",
    marginBottom: "2px",
  },
  serviceInfo: {
    fontSize: "13px",
    color: "#4a5568",
    marginBottom: "2px",
  },
  priceTag: {
    fontSize: "11px",
    color: "#718096",
    fontWeight: "500",
  },
  policySection: {
    padding: "12px",
  },
  policyTitle: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#2d3748",
    marginBottom: "2px",
  },
  policyText: {
    fontSize: "12px",
    color: "#4a5568",
    lineHeight: "1.4",
  },
  paymentSection: {
    marginBottom: "8px",
  },
  paymentTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#2d3748",
    marginBottom: "8px",
  },
  paymentRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  paymentLabel: {
    fontSize: "13px",
    color: "#718096",
    fontWeight: "400",
  },
  paymentValue: {
    fontSize: "13px",
    color: "#2d3748",
    fontWeight: "500",
  },
  actionButtons: {
    position: "sticky",
    bottom: 0,
    display: "flex",
    gap: "12px",
    padding: "16px",
    paddingBottom: "calc(env(safe-area-inset-bottom) + 16px)",
    paddingLeft: "calc(env(safe-area-inset-left) + 16px)",
    paddingRight: "calc(env(safe-area-inset-right) + 16px)",
    backgroundColor: white,
    borderTop: "1px solid #e0e0e0",
    justifyContent: "center",
    zIndex: 10,
    marginTop: "auto",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.up("md")]: {
      padding: "20px 24px",
      borderRadius: "0 0 16px 16px",
    },
  },
  backButton: {
    backgroundColor: "transparent",
    margin: 0,
    padding: "7px",
    color: "#222",
    height: 44,
    fontSize: "15px",
    display: "flex",
    width: "100%",
    borderRadius: "25.5px",
    flex: 1,
    border: "1px solid #222",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#DC143C",
      color: "white",
    },
    [theme.breakpoints.up("md")]: {
      margin: "8px",
      maxWidth: "400px",
    },
  },
  confirmCancelButton: {
    backgroundColor: brand?.default,
    margin: 0,
    padding: "7px",
    color: white,
    height: 44,
    fontSize: "15px",
    display: "flex",
    width: "100%",
    borderRadius: "25.5px",
    flex: 1,
    border: 'none',
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textTransform: "uppercase",
    fontWeight: 500,
    "&:active": {
      backgroundColor: brand?.dark
    },
    [theme.breakpoints.up("md")]: {
      backgroundColor: brand?.default,
      color: white,
      margin: "8px",
      maxWidth: "400px",
    },
  },
}));

export default MuiStylesAppointmentCancelDialog;


